// extracted by mini-css-extract-plugin
export var actionIcon = "_vc-0";